import React from "react";
import {
	Container,
	Dropdown,
	Grid,
	Header,
	Image,
	List,
	Menu,
	Segment,
	Button,
	Responsive,
	Divider
} from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { Link } from "react-router-dom";
import "./AppTemplateComponent.css";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { changeLanguage as changeLanguageAction } from "../internationalization/InternationalizationActions";
import { withRouter } from "react-router-dom";
import LoginContainer from "../login/LoginContainer";
import { logout } from "../login/login-form/LoginActions";
import { TenantContext } from "../../tenant/TenantContex";
import { Helmet } from "react-helmet";
import moment from "moment";
import pdf_en from "../../pdfs/en-help.pdf";
import pdf_ar from "../../pdfs/ar-help.pdf";
import CookieConsent, { Cookies } from "react-cookie-consent";


const MenuContent = ({
	loginData,
	changeLanguage,
	activeLangCode,
	t,
	isLoggedIn,
	logout
}) => (
	<TenantContext.Consumer>
		{tenantContext => (
			<Container fluid dir={(activeLangCode === "ar" ? "rtl" : "ltr")}>
				<Helmet>
					<title>{t(tenantContext.prefix + "TabTitle")}</title>
					<meta
						name="description"
						content={t(tenantContext.prefix + "TabTitle")}
					/>
					<meta
						name="theme-color"
						content={t(tenantContext.themeColor)}
					/>
					<link
						rel="manifest"
						href={process.env.PUBLIC_URL + "/" + tenantContext.prefix + "Manifest.json"}
					/>
				</Helmet>
				<CookieConsent
					buttonText={t("cookieConsentButtonText")}				
				>
				{t("cookieConsent")}
				</CookieConsent>
			
				{!tenantContext.modules.onlineSurveyVisible && 
				<Menu.Item as={Link} to={process.env.PUBLIC_URL} header>
					<Image
						size="medium"
						src={process.env.PUBLIC_URL + "/images/unido_logo.png"}
						style={{ width: "200px" }}
					/>
				</Menu.Item>
				}
				
				<Menu.Item as={Link} to={process.env.PUBLIC_URL + "/"}>
					<Header as="h3">
					{!tenantContext.modules.onlineSurveyVisible &&
						<Image display="block"
							src={process.env.PUBLIC_URL + "/images/" + (activeLangCode === "en" ? tenantContext.logoEN : tenantContext.logoAR)}
							style={{ marginRight: "0.5em", width: tenantContext.logoWidth }}
						/>}
						{tenantContext.modules.onlineSurveyVisible && 
						<Header.Content color="red">
						<Image display="block"
							src={process.env.PUBLIC_URL + "/images/" + (activeLangCode === "en" ? tenantContext.logoEN : tenantContext.logoAR)}
							style={{ marginRight: "0.5em", width: tenantContext.logoWidth }}
						/>	<font color="#ca3338">
							{t(tenantContext.prefix + "Title1")}
							</font>
							<Header.Subheader  color="red">
							<font color="#ca3338">	
								{t(tenantContext.prefix + "Title2")}
							</font>	
							</Header.Subheader>
						</Header.Content>

						}
					</Header>
				</Menu.Item>
				{!tenantContext.modules.onlineSurveyVisible && 
					<Link to={process.env.PUBLIC_URL +  "/"} className="item" style={{ color: "#0e0e0e" }}>
						{t("home")}
					</Link>
				}
				{false && tenantContext.modules.onlineSurveyVisible && (
					<Link
						to={process.env.PUBLIC_URL + "/dynamic-survey"}
						className="item"
						style={{ color: "#0e0e0e" }}
					>
						{t("onlineSurvey")}
					</Link>
				)}
				{tenantContext.hasMenuDatabases && (
				<Dropdown
					item
					simple
					text={t("databases")}
					style={{ color: "#0e0e0e", maxWidth: "300px" }}
				>
					<Dropdown.Menu>
						{tenantContext.modules
							.keyIndustrialIndicatorsVisible && (
							<Link to="/survey_data_visualization">
								<Dropdown.Item style={{ color: "#0e0e0e" }}>
									{t("surveyDataVisualization")}
								</Dropdown.Item>
							</Link>
						)}
						{tenantContext.modules
							.directoryOfManufacturingVisible && (
							<Link to="/directory_of_manufactory">
								<Dropdown.Item style={{ color: "#0e0e0e" }}>
									{t("directoryOfManufactory")}
								</Dropdown.Item>
							</Link>
						)}
						{tenantContext.modules.statisticalTablesVisible && (
							<Link to="/statistical_tables">
								<Dropdown.Item style={{ color: "#0e0e0e" }}>
									{t("statisticalTables")}
								</Dropdown.Item>
							</Link>
						)}
						{tenantContext.modules.performanceMonitoringVisible && (
							<Link to="/performance_monitoring">
								<Dropdown.Item style={{ color: "#0e0e0e" }}>
									{t("performanceMonitoring")}
								</Dropdown.Item>
							</Link>
						)}
						{tenantContext.modules.publicationsVisible && (
							<Link to="/publications">
								<Dropdown.Item style={{ color: "#0e0e0e" }}>
									{t("publications")}
								</Dropdown.Item>
							</Link>
						)}						
					</Dropdown.Menu>
				</Dropdown>
				)}
				{tenantContext.helpLink &&
					<Menu.Item as={"a"} href={process.env.PUBLIC_URL + tenantContext.helpLink + activeLangCode + "-help.pdf"} target="_blank" style={{ color: "#0e0e0e" }}>
						{t("help")}
					</Menu.Item>
				}

				{tenantContext.instructionsLink && 
					<Menu.Item position="right" as={"a"} href={activeLangCode === "ar" ? pdf_ar : pdf_en} target="_blank" style={{ color: "#0e0e0e" }}>
						{t("instructions")}
					</Menu.Item>
				}				

				{isLoggedIn && 
				<Menu.Item position={activeLangCode === "ar" ? "left" : "right"} as="a" style={{ color: "#0e0e0e" }}>
						{t("welcome")} {loginData["firstname"]}  {loginData["lastname"]}
				</Menu.Item>}

				<Menu.Menu position={activeLangCode === "ar" ? "left" : "right"}>
					<Menu.Item>
						<div>
							{!isLoggedIn && !tenantContext.modules.onlineSurveyVisible && (
								<LoginContainer
									trigger={
										<Button
											compact
											basic
											inverted
											//   style={{ backgroundColor: tenantContext.secondaryColor }}
										>
											{t("loginRegister")}
										</Button>
									}
								/>
							)}

							{isLoggedIn && (
								<Button
									as={Link}
									compact
									basic
									inverted
									//   style={{ backgroundColor: tenantContext.secondaryColor }}
									//onClick={logout}
									to="/logout"
								>
									{t("logout")}
								</Button>
							)}

							<span> </span>
								<Button
									compact
									inverted
									//   style={{ backgroundColor: tenantContext.secondaryColor }}
									onClick={() => changeLanguage("en")}
									active={activeLangCode === "en"}
								>
									English
								</Button>
								<Button
									compact
									inverted
									//   style={{ backgroundColor: tenantContext.secondaryColor }}
									onClick={() => changeLanguage("ar")}
									active={activeLangCode === "ar"}
								>
									عربي
								</Button>
						</div>
					</Menu.Item>
				</Menu.Menu>
			</Container>
		)}
	</TenantContext.Consumer>
);

class HtmlTemplate extends React.Component {
	constructor(props, context) {
		super(props);
	}

	render() {
		const { dispatch, children, i18n, t, activeLangCode } = this.props;

		const changeLanguage = lng => {
			dispatch(changeLanguageAction(lng));
			i18n.changeLanguage(lng);
			moment.locale(lng);
			//window.location.reload(true)
		};

		const logoutClick = () => {
				//if(window.confirm(t("confirmLeave"))) {					
					dispatch(logout());
					this.props.history.push(process.env.PUBLIC_URL + "/");
			//}
		};

		return (
			<TenantContext.Consumer>
				{tenantContext => (
					<div>
						<Responsive
							{...Responsive.onlyMobile}
							as={Menu}
							style={{ backgroundColor: tenantContext.baseColor }}
							borderless
							stackable
						>
							<MenuContent dir="rtl"
								loginData={this.props.loginData}
								logout={logoutClick}
								isLoggedIn={this.props.isLoggedIn}
								changeLanguage={changeLanguage}
								activeLangCode={activeLangCode}
								t={t}
							/>
						</Responsive>

						<Responsive
							minWidth={Responsive.onlyTablet.minWidth}
							maxWidth={1119}
							as={Menu}
							style={{ backgroundColor: tenantContext.baseColor }}
							borderless
							stackable
							fluid
							vertical
						>
							<MenuContent
								loginData={this.props.loginData}
								logout={logoutClick}
								isLoggedIn={this.props.isLoggedIn}
								changeLanguage={changeLanguage}
								activeLangCode={activeLangCode}
								t={t}
							/>
						</Responsive>

						<Responsive
							minWidth={1120}
							as={Menu}
							fixed="top"
							style={{ backgroundColor: tenantContext.baseColor }}
							borderless
							stackable
							fluid
						>
							<MenuContent
								loginData={this.props.loginData}
								logout={logoutClick}
								isLoggedIn={this.props.isLoggedIn}
								changeLanguage={changeLanguage}
								activeLangCode={activeLangCode}
								t={t}
							/>
						</Responsive>

						<Grid centered stackable className="containerCustom">
							<Grid.Row centered>
								<Grid.Column
									computer={16}
									mobile={16}
									largeScreen={16}
								>
									{children}
								</Grid.Column>
							</Grid.Row>
						</Grid>

						<Segment
							vertical
							style={{
								margin: "3em 0em 0em",
								padding: "2em 0em",
								backgroundColor: tenantContext.baseColor
							}}
						>  							
							<Container
								textAlign="center"
								style={{
									color: "#0e0e0e",
									backgroundColor: tenantContext.baseColor
								}}
							>
								
								{tenantContext.hasFooterLinks && (
								<Grid centered>
									<Grid.Row>
										<Grid.Column width={3}>
											<Header
												inverted
												as="h4"
												content={t("footerGroup1")}
												style={{ color: "#0e0e0e" }}
											/>
											<List link inverted>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup1Link1")}
												</List.Item>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup1Link2")}
												</List.Item>
											</List>
										</Grid.Column>
										<Grid.Column width={3}>
											<Header
												inverted
												as="h4"
												content={t("footerGroup2")}
												style={{ color: "#0e0e0e" }}
											/>
											<List link inverted>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup2Link1")}
												</List.Item>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup2Link2")}
												</List.Item>
											</List>
										</Grid.Column>
										<Grid.Column width={3}>
											<Header
												inverted
												as="h4"
												content={t("footerGroup3")}
												style={{ color: "#0e0e0e" }}
											/>
											<List link inverted>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup3Link1")}
												</List.Item>
												<List.Item
													as="a"
													style={{ color: "#0e0e0e" }}
												>
													{t("footerGroup3Link2")}
												</List.Item>
											</List>
										</Grid.Column>										
										<Grid.Column width={3}>
											<Header
												inverted
												as="h4"
												content={t("footerHeader")}
												style={{ color: "#0e0e0e" }}
											/>
											<p>{t("footerHeaderLink")}</p>
										</Grid.Column>
									</Grid.Row>
								</Grid>
								)}
								<Divider inverted section />
								<Image
									centered
									size="medium"
									src={process.env.PUBLIC_URL + "/images/unido_logo.png"}
									style={{ marginBottom: "10px" }}
								/>
								{tenantContext.hasSubfooterLinks && (
								<List horizontal inverted divided link>
									<List.Item
										as="a"
										href="#"
										style={{ color: "#0e0e0e" }}
									>
										{t("siteMap")}
									</List.Item>
									<List.Item
										as="a"
										href="#"
										style={{ color: "#0e0e0e" }}
									>
										{t("contactUs")}
									</List.Item>
									<List.Item
										as="a"
										href="#"
										style={{ color: "#0e0e0e" }}
									>
										{t("termsAndConditions")}
									</List.Item>
									<List.Item
										as="a"
										href="#"
										style={{ color: "#0e0e0e" }}
									>
										{t("privacyPolicy")}
									</List.Item>
								</List>									
								)}
								</Container>
						</Segment>
					</div>					
				)}
			</TenantContext.Consumer>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		activeLangCode: state.internationalizationReducer.activeLangCode,
		isLoggedIn: state.loginReducer.isLoggedIn,
		tenant: state.tenantReducer,
		loginData: state.loginReducer.loginData,
		unsavedForm: state.dynamicSurveyReducer.unsavedForm
	};
};

export default withRouter(connect(mapStateToProps)(translate()(HtmlTemplate)));




// WEBPACK FOOTER //
// ./src/features/common/template/AppTemplateComponent.js